import type {
    FormElementConfig,
    FormFieldConfig,
    FormFieldValue,
    TextAreaFieldConfig,
    TextFieldConfig,
} from '../../types/form-builder.types';

export const isFieldConfig = (config: FormElementConfig): config is FormFieldConfig =>
    config.type !== 'button' && config.type !== 'submit' && config.type !== 'divider';

const isTextLikeFieldConfig = (fieldConfig: FormFieldConfig): fieldConfig is TextFieldConfig | TextAreaFieldConfig =>
    fieldConfig.type === 'text' ||
    fieldConfig.type === 'number' ||
    fieldConfig.type === 'email' ||
    fieldConfig.type === 'textarea';

export const normalizeFieldValue = (fieldConfig: FormFieldConfig, value: FormFieldValue): FormFieldValue => {
    if (isTextLikeFieldConfig(fieldConfig) && typeof value === 'number') {
        return String(value);
    }

    return value;
};

export const getDefaultValue = (fieldConfig: FormFieldConfig): FormFieldValue => {
    switch (fieldConfig.type) {
        case 'checkbox': {
            return false;
        }
        case 'checkbox-group': {
            return [];
        }
        default: {
            return '';
        }
    }
};

export const isEmpty = (value: FormFieldValue): boolean => {
    if (typeof value === 'string') {
        return value === '';
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === 'boolean') {
        return !value;
    }
    return false;
};

/** Whether two FormFieldValues are equal. Handles array comparison by value. */
export const isValueEqual = (a: FormFieldValue, b: FormFieldValue): boolean => {
    if (Array.isArray(a) && Array.isArray(b)) {
        return a.length === b.length && a.every((value, index) => value === b[index]);
    }
    return a === b;
};
